import { Lisio } from "../../lisio";

function lisioActiveResponseMessageHandler(this: Lisio, datas: string) {
  //lisioGetTradText(this.lisioTranslation.langIso)
  const { value, isConfigured }: { value: boolean; isConfigured: boolean } =
    JSON.parse(datas);
  this.popin?.refreshLabel(value, isConfigured);
  this.setDisableBand(value);
  if (!value && isConfigured) {
    window.dispatchEvent(new CustomEvent("lisio-disabled"));
  }
}

export { lisioActiveResponseMessageHandler };
